import { useQuery } from '@tanstack/react-query';

import { Service } from '@/infra/services/bera';
import { NoENSTask } from '@/types/Bera';

export interface GetNoENSTasksParams {
	id: string;
	organization_id: string;
	company_id: string;
	limit: number;
	offset: number;
	min_rpn?: number;
}

export type GetNoENSTasksResponse = {
	total: number;
	rows: NoENSTask[];
	limit: number;
	offset: number;
};

export function useGetBeraNoENSTasks(params: GetNoENSTasksParams) {
	const enabled = !!params.organization_id && !!params.company_id && !!params.id && !!params.limit && !!params.offset;
	return useQuery<GetNoENSTasksResponse, Error>(
		['bera_no_ens_tasks', [params.organization_id, params.company_id, params.id, params.limit, params.offset]],
		() => Service.getNoENSTasks(params),
		{
			enabled,
			retry: 0
		}
	);
}
